import { render } from "./wDateTime.vue?vue&type=template&id=33e6cefa&ts=true"
import script from "./wDateTime.vue?vue&type=script&lang=ts"
export * from "./wDateTime.vue?vue&type=script&lang=ts"

import exportComponent from "E:\\Work\\Sales point\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__